module.exports = __webpack_public_path__ + "img/افقی.2a0a1536.png";